/* DSL UTM capture — persist UTM-params in localStorage, forward to checkout via cart-attributes */
(function(){
  var KEY = "dsl_utm";
  var p = new URLSearchParams(location.search);
  var utm = {};
  ["utm_source","utm_medium","utm_campaign","utm_term","utm_content","gclid","fbclid"].forEach(function(k){
    if (p.has(k)) utm[k] = p.get(k);
  });
  if (Object.keys(utm).length) {
    utm.ts = Date.now();
    utm.landing = location.pathname;
    try { localStorage.setItem(KEY, JSON.stringify(utm)); } catch(e){}
    if (window.DSL_AB) window.DSL_AB.track("utm_capture", utm);
  }
  document.addEventListener("dsl:cart:add", function(){
    var stored;
    try { stored = JSON.parse(localStorage.getItem(KEY) || "null"); } catch(e){}
    if (!stored) return;
    fetch("/cart/update.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({attributes: stored})}).catch(function(){});
  });
})();